module.exports = __webpack_public_path__ + "static/media/logo_nuitrack_b.e32c9c92.svg";